export default "__VITE_ASSET__BGz7R3YD__"